import { Component, Input } from '@angular/core';

@Component({
    selector: 'cv-forms-assign',
    templateUrl: './forms-assign.component.html',
    styleUrls: ['./../forms.component.scss']
})
export class FormsAssignComponent {

    @Input() showall: boolean = true;
    @Input() lst: any[];
    @Input() onremove;
    @Input() empgrouptypes;
    @Input() recgrouptypes;

    constructor() { }

    public filteredList(baseGroupType: number, groupLevel: number) {
        return this.lst.filter(o => o.BaseGroupType == baseGroupType && (o.GroupLevel == groupLevel || groupLevel == 0));
    }

}
